module.exports = __webpack_public_path__ + "img/hero-sky-min.0397f4dc.jpg";